import Link from "next/link";
import { Separator } from "@/components/ui/separator";
import { Avatar, AvatarImage } from "../ui/avatar";
import logoMinistero from "../../../public/loghi/ministero.svg";
import logoFism from "../../../public/loghi/fism.svg"
import { Facebook, Instagram, Youtube } from "lucide-react";
import { schoolContact } from "@/lib/school-contact";
import FooterNavLinks from "@/components/shared/footer-nav-links";

export default function Footer() {
  const footerLinkClass =
    "hover:underline underline-offset-4 focus-visible:underline focus-visible:underline-offset-4";

  return (
    <>
      <Separator />
      <footer className="bg-[#0b7bb2] px-8 lg:px-4 py-12 text-[#fefefe]">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-4 gap-4">
          {/* Branding */}
          <div className="space-y-4 text-left sm:text-center lg:text-left">
            {/* Flex con larghezza controllata per evitare sovrapposizioni */}
            <div className="flex flex-row gap-4 justify-start sm:justify-center lg:justify-start items-center">
              {/* Modificato per evitare sovrapposizioni */}
              <Avatar className="w-20 h-20 shrink-0">
                <AvatarImage src={logoMinistero.src} alt="Ministero"/>
              </Avatar>
              <Avatar className="w-20 h-20 shrink-0">
                <AvatarImage src={logoFism.src} alt="Santa Marta" />
              </Avatar>
            </div>
            <p className="text-sm text-[#fefefe] leading-relaxed">
              {schoolContact.name}
            </p>
            <address className="text-sm text-[#fefefe]/90 not-italic leading-relaxed space-y-1">
              <p>{schoolContact.addressShort}</p>
              <p>
                <a href={schoolContact.phone.href} className={footerLinkClass}>
                  {schoolContact.phone.display}
                </a>
              </p>
              <p>
                <Link href="/contatti" className={`${footerLinkClass} underline`}>
                  Tutti i contatti e dati istituzionali
                </Link>
              </p>
            </address>
          </div>

          {/* Link Navigazione */}
          <div className="lg:col-span-3 grid grid-cols-2 lg:grid-cols-3 gap-6 text-left sm:text-center lg:text-left">
            <div>
              <h4 className="font-bold text-[#fefefe] mb-2">
                Navigazione
              </h4>
              <FooterNavLinks linkClass={footerLinkClass} />
            </div>
            <div>
              <h4 className="font-bold text-[#fefefe] mb-2">
                Social
              </h4>
              <div className="flex flex-col items-start sm:items-center lg:items-start gap-2">
                <a
                  href="https://youtube.com/@scuoladellinfanziasantamar2086?si=q5PXiv_VgBXA6u8D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex items-center gap-2 ${footerLinkClass}`}
                >
                  <Youtube className="w-4 h-4text-[#fefefe]" />
                  Youtube
                </a>
                <a
                  href="https://www.facebook.com/scuolasantamarta/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex items-center gap-2 ${footerLinkClass}`}
                >
                  <Facebook className="w-4 h-4 text-[#fefefe]" />
                  Facebook
                </a>
                <a
                  href="https://www.instagram.com/santamartacasabetania"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex items-center gap-2 ${footerLinkClass}`}
                >
                  <Instagram className="w-4 h-4 text-[#fefefe]" />
                  Instagram
                </a>
              </div>
            </div>
            <div>
              <h4 className="font-bold text-[#fefefe] mb-2">
                Legale
              </h4>
              <ul className="space-y-1 text-sm">
                <li>
                  <Link href="/privacy-policy" className={footerLinkClass}>Privacy Policy</Link>
                </li>
                <li>
                  <Link href="/cookie-policy" className={footerLinkClass}>Cookie Policy</Link>
                </li>
                <li>
                  <Link href="#" className={footerLinkClass}>Termini di Servizio</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Separator className="my-4" />

        {/* Bottom note */}
        <div className="text-xs text-[#fefefe] text-center">
          <p>
            © {new Date().getFullYear()} Scuola dell'infanzia Santa Marta. Tutti
            i diritti riservati.
          </p>
        </div>
      </footer>
    </>
  );
}